// src/components/Gallery.js
import { useState } from 'react';

function Gallery() {
  // Array of image numbers (1-9)
  const imageNumbers = Array.from({ length: 9 }, (_, i) => i + 1);
  const [loadedImages, setLoadedImages] = useState(new Set());

  const handleImageLoad = (num) => {
    setLoadedImages(prev => new Set([...prev, num]));
  };

  const handleImageError = (e, num) => {
    e.target.onerror = null;
    e.target.style.display = 'none';
    e.target.parentNode.classList.add('no-image');
    e.target.parentNode.textContent = `Tattoo Artwork ${num}`;
  };

  return (
    <section className="gallery" id="gallery">
      <h2>Gallery</h2>
      <div className="gallery-grid">
        {imageNumbers.map((num) => (
          <div key={num} className="gallery-item">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/tattoo${num}.jpg`} 
              alt={`Fine line tattoo artwork piece ${num} by Steff - detailed ink design`}
              className="gallery-image"
              loading="lazy"
              decoding="async"
              sizes="(max-width: 480px) 100vw, (max-width: 768px) 50vw, 33vw"
              onLoad={() => handleImageLoad(num)}
              onError={(e) => handleImageError(e, num)}
              style={{
                opacity: loadedImages.has(num) ? 1 : 0,
                transition: 'opacity 0.3s ease'
              }}
            />
            {!loadedImages.has(num) && (
              <div className="image-loading-placeholder">
                Loading...
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;